import HttpClient from '@/services/http-client'

class MeterGroupService extends HttpClient {
  async show(id) {
    return this.rest.get('/v1/meter-groups/' + id)
  }

  async list(page = 1, limit = 1000, text = null) {
    return this.rest.get('/v1/meter-groups', {
      params: {
        page,
        limit,
        q: text
      }
    })
  }

  async create(payload) {
    return this.rest.post('/v1/meter-groups', payload)
  }

  async update(payload) {
    return this.rest.patch('/v1/meter-groups/' + payload.id, payload)
  }

  async delete(id) {
    return this.rest.delete('/v1/meter-groups/' + id)
  }
}

export default () => new MeterGroupService()
